import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
export const CHECKOUT_URL = 'https://digitopuntura.impultienda.ar/checkout';
type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
  glow?: boolean;
};
export function Section({
  children,
  className = '',
  id = '',
  glow = false
}: SectionProps) {
  const reduceMotion = useReducedMotion();
  return <motion.section id={id} initial={reduceMotion ? false : {
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.45,
    ease: [0.22, 1, 0.36, 1]
  }} className={`relative mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 md:py-20 lg:px-8 ${className}`} data-id="element-301" data-mp="ahwzz25mnl8c">
      {glow && <div className="absolute inset-x-[12%] top-10 -z-10 h-48 rounded-full bg-brand-greenSage/45 blur-3xl" aria-hidden="true" data-id="element-302" data-mp="20srx8sp0f58a" />}
      {children}
    </motion.section>;
}
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'purple' | 'gold';
};
export function CTAButton({
  children,
  href = CHECKOUT_URL,
  className = '',
  fullWidth = false,
  variant = 'purple'
}: CTAButtonProps) {
  const reduceMotion = useReducedMotion();
  const colorClass = variant === 'purple' ? 'purple-gradient-bg' : 'gold-gradient-bg';
  return <motion.a href={href} whileHover={reduceMotion ? undefined : {
    scale: 1.02,
    y: -1
  }} whileTap={reduceMotion ? undefined : {
    scale: 0.98
  }} className={`cta-shimmer relative inline-flex items-center justify-center rounded-full px-8 py-4 text-center text-base font-bold text-white shadow-[0_8px_20px_rgba(117,58,49,0.26)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-ink ${colorClass} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-303" data-mp="2lsc42m34glpq">
      <span className="relative z-10" data-id="element-304" data-mp="1jb2jdtz25lkt">{children}</span>
    </motion.a>;
}